import { LinkKind } from '@care/navigation/dist/components/GlobalNavIA/NavLinkList/NavLinkList';
import { seoNavigationLinkSection_seoNavigationLinkSection_SEONavigationLinkSectionSuccess_seoNavigationLinkSection_childCareLinks as SEONavigationLink } from '@/__generated__/seoNavigationLinkSection';
import { convertSeoNavLinkToVgnLink } from './convertSeoNavLinkToVgnLink';
import { getVerticalIntroductoryLink } from './getVerticalIntroductoryLink';

export const buildVgnLinkList = (
  baseURL: string,
  key: string,
  linkList: SEONavigationLink[],
  isLargeViewport: boolean
): LinkKind[] => {
  const linkType = key === 'jobsLinks' ? 'secondary' : 'primary';
  const vgnLinkList: LinkKind[] = linkList.map((link: SEONavigationLink) =>
    convertSeoNavLinkToVgnLink(baseURL, link, linkType)
  );

  // Add a "View all categories" link to the tutoring vertical.
  if (key === 'tutoringLinks') {
    vgnLinkList.push({
      kind: 'link',
      id: 'view-all-categories',
      href: `${baseURL}/care-directory#care`,
      value: 'View all categories',
      linkType: 'primary',
    });
  }

  // Add a "View all categories" link to the jobs vertical.
  if (key === 'jobsLinks') {
    vgnLinkList.push({
      kind: 'link',
      id: 'view-all-categories',
      href: `${baseURL}/care-directory#jobs`,
      value: 'View all categories',
      linkType: 'secondary',
    });
  }

  // Add an introductory link to the beginning of vgnLinkList if the viewport is not large.
  if (key !== 'jobsLinks' && !isLargeViewport) {
    const introductoryLink = getVerticalIntroductoryLink(baseURL, key);
    return [introductoryLink, ...vgnLinkList];
  }

  return vgnLinkList;
};
